import Image from '@base/components/src/Image';
import Link from '@base/components/src/Link';
import Rating from '@base/components/src/Rating';
import currencyFormatting from '@package/utils/src/currencyFormatting';
import clsx from 'clsx';
import config from 'config-base';
import AddonButton from '../AddonButton';
import { AddonCardProps } from './types';
import styles from './AddonCard.module.css';

const AddonCard = ({
  data,
  onAddProduct,
  outOfStock,
  onClick,
}: AddonCardProps) => (
  <Link
    classes={clsx(styles.card, { [styles.cardAGD]: config.brandCode !== '0' })}
    showCursorPointer={Boolean(onClick)}
    href={data.productUrl}
    onClick={onClick}
    data-testid="addons-product-card"
  >
    <Image
      className={styles.cardMedia}
      src={data.smallImage || data.image || '../../../marketplace-static/images/TestGunImage1.png'}
      alt={data.name}
      width={180}
      height={141}
    />
    <div className={styles.cardContent}>
      {typeof data.rating === 'number' && (
        <Rating
          hideRating={true}
          reviewers={data.reviewsCount}
          defaultValue={data.rating}
          ratingContainerClasses={styles.ratingContainer}
        />
      )}
      <div className={`${styles.cartName} ${styles.cartNameClamp}`}>{data.name}</div>
      <div className={styles.cardPrice}>
        <div className={styles.cardPriceText}>{currencyFormatting(data.discountPrice || data.price)}</div>
        {Boolean(data.discountPrice) && <div className={styles.oldPrice}>{currencyFormatting(data.price)}</div>}
      </div>
    </div>
    <AddonButton outOfStock={outOfStock} onClick={onAddProduct} />
  </Link>
);

export default AddonCard;
